import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMemo } from "react";
import { useSingleObjetivo } from "../../../../context/SuperAdmin/OASContexts/SingleObjetivoContext";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import { IndicadoresRow } from "./IndicadoresRow";

const IndicadoresTable = () => {
  const {
    indicadores,
    setSelectedIndicadores,
    selectedIndicadores,
    searchText,
  } = useSingleObjetivo();

  const selectAll = () => {
    setSelectedIndicadores(filteredIndicadores.map((obj) => obj.id_indicador));
  };

  // Manejar selección/deselección de un objetivo
  const handleSelect = (id: string) => {
    setSelectedIndicadores((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // Filtro de indicadores por búsqueda
  const filteredIndicadores = useMemo(() => {
    const normalizedSearch = searchText.toLowerCase().trim();
    return indicadores.filter((u) =>
      u.nombre.toLowerCase().includes(normalizedSearch)
    );
  }, [indicadores, searchText]);

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell sx={{ maxWidth: "100px", width: 50 }}>
              <Checkbox
                color="primary"
                checked={selectedIndicadores.length > 0} // Check general
                onChange={(e) => {
                  if (e.target.checked) {
                    selectAll();
                  } else {
                    setSelectedIndicadores([]);
                  }
                }}
                sx={{
                  color: "white", // Color del checkbox cuando no está seleccionado
                  "&.Mui-checked": {
                    color: "white", // Color del icono cuando está seleccionado
                  },
                  "& .MuiSvgIcon-root": {
                    border: "2px solid white", // Borde blanco alrededor del checkbox
                    borderRadius: "4px", // Bordes redondeados
                  },
                }}
              />
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              N°
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center", maxWidth: 400 }}>
              Contenido
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Acciones
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredIndicadores.length > 0 ? (
            filteredIndicadores.map((item, index) => (
              <IndicadoresRow
                indicador={item}
                i={index + 1}
                key={item.id_indicador}
                handleSelect={handleSelect}
                isSelected={selectedIndicadores.includes(item.id_indicador)}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default IndicadoresTable;
